import { render } from "./settingPart.vue?vue&type=template&id=552062e8&scoped=true"
import script from "./settingPart.vue?vue&type=script&lang=js"
export * from "./settingPart.vue?vue&type=script&lang=js"

import "./settingPart.vue?vue&type=style&index=0&id=552062e8&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552062e8"]])

export default __exports__